import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { IUserInfo } from "../store/actions";
import "./Layout.css";
import userPresenter from "../authentications/userPresenter";
import Login from "../authentications/Login";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React from "react";
import FormExportActions from "./FormExportActions";

const Layout = () => {
  const currentUserInfo: IUserInfo = useSelector((state: any) => {
    return state.userAuthInfoState;
  });

  const navigate = useNavigate();
  const [chassisNo, setChassisNo] = React.useState("");
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && chassisNo.trim() !== "") {
      event.preventDefault();
      navigate(`${window.location.pathname}?chassisNo=${chassisNo}`, {
        replace: true,
      });
    }
  };

  const logout = () => {
    userPresenter.logOut();
    navigate("/login");
  };

  const hasRole = (role: string) =>
    currentUserInfo?.roles?.includes("admin") ||
    currentUserInfo?.roles?.includes(role);
  const isAdmin = currentUserInfo?.roles?.includes("admin");

  return (
    <main className="App">
      {currentUserInfo?.roles ? (
        <nav className="navbar nav fixed-top navbar-expand-xl">
          <div className="container-fluid">
            <div className="d-flex flex-row-reverse flex-lg-row align-items-center gap-2">
              <h1 className="m-0 d-flex justify-content-center align-items-center">
                <div className="logo navbar-brand p-0 m-0 d-flex justify-content-center align-items-center">
                  <img src="./Crusader_Shield.png" alt="Logo" />
                </div>
              </h1>
            </div>
            <div className="d-flex align-items-center mx-3">
              {(hasRole("line-manager-qc") || hasRole("quality-assurance")) && (
                <TextField
                  placeholder="Chassis No"
                  variant="outlined"
                  size="small"
                  onChange={(e) => setChassisNo(e.target.value)}
                  onKeyPress={handleKeyPress}
                  autoComplete="off"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "5px",
                    maxWidth: "220px",
                    "& .MuiOutlinedInput-root": {
                      height: "40px",
                      paddingLeft: "8px",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInputBase-input": {
                      padding: "10px",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" sx={{ fontSize: "20px" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            </div>

            <div className="d-flex align-items-center gap-4">
              <button
                className="navbar-toggler border-0 text-black p-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span
                  className="navbar-toggler-icon"
                  style={{ filter: "invert(1)" }}
                ></span>
              </button>
            </div>
            {currentUserInfo.accessToken && currentUserInfo.roles && (
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav me-auto align-items-start align-items-xl-center mt-2 mt-xl-0">
                  {(hasRole("chassis_prep") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/incoming-chassis-quality-inspection"
                        className="nav-link"
                      >
                        Incoming Chassis
                      </NavLink>
                    </li>
                  )}

                  {(hasRole("chassis-elec-qa") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/electrical-chassis-prep"
                        className="nav-link"
                      >
                        Electrical Chassis Prep
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("furniture_prep") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/furniture-quality-inspection"
                        className="nav-link"
                      >
                        Furniture
                      </NavLink>
                    </li>
                  )}

                  {(hasRole("floor_and_lino_assembly") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/floor-quality-inspection"
                        className="nav-link"
                      >
                        Floor Quality
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("builder-qc") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/building-quality-inspection"
                        className="nav-link"
                      >
                        Building
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("quality-assurance") ||
                    hasRole("builder-qc") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/post-building-quality-inspection"
                        className="nav-link"
                      >
                        Post Building
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("electrical-qc") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/electrical-bms-quality-inspection"
                        className="nav-link"
                      >
                        Electrical-BMS
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("electrical-qc") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/electrical-fit-off-quality-inspection"
                        className="nav-link"
                      >
                        Electrical Fit-Off
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("wall_assembly_prep") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/side-walls-quality-inspection"
                        className="nav-link"
                      >
                        Side Walls
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("roof_assembly_prep") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/roof-quality-inspection"
                        className="nav-link"
                      >
                        Roof
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("j-mould") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/j-mould-quality-inspection"
                        className="nav-link"
                      >
                        J.Mould
                      </NavLink>
                    </li>
                  )}

                  {(hasRole("electrical-qc") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/electrical-quality-inspection"
                        className="nav-link"
                      >
                        Electrical
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("quality-assurance") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink to="/qa-quality-inspection" className="nav-link">
                        QA
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("plumber") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/quality-control-plumbing"
                        className="nav-link"
                      >
                        Plumbing
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("quality-assurance") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/finishing-quality-inspection"
                        className="nav-link"
                      >
                        Finishing
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("sealing") ||
                    hasRole("quality-assurance") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/sealing-quality-inspection"
                        className="nav-link"
                      >
                        Sealing
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("quality-assurance") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink to="/qa-green-tag" className="nav-link">
                        Green Tag
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("doors_and_drawers_prep") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/doors-drawers-benchtops-quality-inspection"
                        className="nav-link"
                      >
                        Doordwr-benchtp
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("electrical-qc") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/electrical-final-quality-inspection"
                        className="nav-link"
                      >
                        Electrical-Final
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("quality-assurance") ||
                    hasRole("cleaning") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/cleaning-quality-inspection"
                        className="nav-link"
                      >
                        Cleaning
                      </NavLink>
                    </li>
                  )}

                  {(hasRole("quality-assurance") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/gp12-quality-inspection"
                        className="nav-link"
                      >
                        QUALITY CONTROL INSPECTION
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("quality-assurance") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink to="/svi-checklist" className="nav-link">
                        FINAL AUDIT
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("compliance") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc")) && (
                    <li className="nav-item">
                      <NavLink
                        to="/compliance-quality-inspection"
                        className="nav-link"
                      >
                        Compliance
                      </NavLink>
                    </li>
                  )}
                  {(hasRole("quality-assurance") ||
                    hasRole("line-manager-qc") ||
                    hasRole("qa-manager-qc") ||
                    hasRole("electrical-qc")) && (
                    <li className="nav-item">
                      <NavLink to="/rework-summary" className="nav-link">
                        Rework Summary
                      </NavLink>
                    </li>
                  )}
                  {isAdmin && (
                    <>
                      <li className="nav-item">
                        <NavLink to="/create-user" className="nav-link">
                          Create User
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink to="/user-management" className="nav-link">
                          User Management
                        </NavLink>
                      </li>
                    </>
                  )}

                  <li>
                    <span className="d-flex justify-content-center align-items-center gap-3">
                      <span className="user-info position-relative d-flex justify-content-center align-items-center">
                        <span className="m-0 text-white user-info__tooltip font-md">
                          {currentUserInfo.name}
                        </span>
                        <img
                          className="button__image"
                          src="./avatar.jpeg"
                          alt=""
                        />
                      </span>
                      <span className="m-0 text-white font-lg">
                        {currentUserInfo?.name}
                      </span>
                    </span>
                  </li>
                  <li className="nav-item">
                    <button
                      className="font-lg d-flex justify-content-center align-items-center bg-transparent border-0"
                      onClick={logout}
                    >
                      <p className="m-0 font-lg text-white">Logout</p>
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </nav>
      ) : (
        <></>
      )}
      <div
        className="container-fluid main-container position-relative"
        style={{ marginTop: "60px" }}
      >
        {currentUserInfo?.roles ? <Outlet /> : <Login />}
      </div>
      {currentUserInfo?.roles && <FormExportActions />}
    </main>
  );
};

export default Layout;
